import i18next from 'i18next';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import React from 'react';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

const USER_ROLES = {
  PROVIDER: 'provider',
  ASSISTANT: 'assistant',
};

export default USER_ROLES;

export const ALLOWED_ACCOUNT_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:account'),
    accessorKey: 'businessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'customIdentifier',
    filter: {},
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 240,
    header: i18next.t('tables:accessGranted'),
    accessorKey: 'isAllowed',
    filter: {
      filterType: FILTER_TYPES.CHECKBOX,
      options: [
        { label: i18next.t('forms:allowed'), value: 'true' },
        { label: i18next.t('forms:notAllowed'), value: 'false' },
      ],
    },
    isDefaultCell: true,
  },
];

export const USERS_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:firstName'),
    accessorKey: 'firstName',
    filter: {},
  },
  {
    size: 200,
    header: i18next.t('tables:lastName'),
    accessorKey: 'lastName',
    filter: {},
  },
  {
    size: 200,
    header: i18next.t('tables:roles'),
    accessorKey: 'role',
    filter: {},
  },
  {
    size: 220,
    header: i18next.t('forms:email'),
    accessorKey: 'email',
    filter: {},
  },
];
